import type { Visualize3dObject } from '../../models/visualize3d-object';
import { Object3D, Scene } from 'three';
import type { Visualize3dUserData } from '../../models/visualize3d-user-data';

export function getRelatedThreeJsObject(scene: Scene, v3dObject: Visualize3dObject): Object3D | undefined {
  if (scene) {
    return tryFindObject3d(scene, o => (o.userData as Visualize3dUserData)?.v3dObject === v3dObject);
  }
  return undefined;
}

export function tryFindObject3d(object3d: Object3D, selector: (o: Object3D) => boolean): Object3D | undefined {
  if (selector(object3d)) {
    return object3d;
  }
  for (const child of object3d.children) {
    const match = tryFindObject3d(child, selector);
    if (match) {
      return match;
    }
  }
  return undefined;
}
